import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-signup-details-slideout',
  templateUrl: './signup-details-slideout.component.html',
  styleUrls: ['./signup-details-slideout.component.css']
})
export class SignupDetailsSlideoutComponent implements OnInit {

 @Input() signUpdetailObj:any;
 @Output() closeModal = new EventEmitter<any>
 
  constructor (){}

  ngOnInit(): void {
  }

  onCloseModal(){
    this.closeModal.emit();
  }

}
